import { ICONS } from 'components/Icons';
import { CoverType, Extra } from 'scenes/common/types';
import { OptionalExtra } from 'scenes/landlord/types';
import {
  tenantDamage as tenantDamageContent,
  lossOfRent as lossOfRentContent,
  fusionBuilding as fusionBuildingContent,
  fusionContents as fusionContentsContent,
  rentDefault as rentDefaultContent,
} from './OptionalExtrasContent';

const tenantDamage = {
  code: OptionalExtra.TenantDamage,
  label: 'Damage caused by tenants',
  summaryLabel: 'Damage caused by tenants',
  image: ICONS.OPTIONAL_EXTRA.LANDLORD.TENANT_DAMAGE,
  content: tenantDamageContent,
};
const lossOfRent = {
  code: OptionalExtra.LossOfRent,
  label: 'Loss of rent cover',
  summaryLabel: 'Loss of rent cover',
  image: ICONS.OPTIONAL_EXTRA.LANDLORD.LOSS_OF_RENT,
  content: lossOfRentContent,
};
const fusionBuilding = {
  code: OptionalExtra.FusionBuilding,
  label: 'Motor burn out cover for Building',
  summaryLabel: 'Motor burn out cover for Building',
  image: ICONS.OPTIONAL_EXTRA.LANDLORD.FUSION_BUILDING,
  content: fusionBuildingContent,
};
const fusionContents = {
  code: OptionalExtra.FusionContent,
  label: 'Motor burn out cover for Contents',
  summaryLabel: 'Motor burn out cover for Contents',
  image: ICONS.OPTIONAL_EXTRA.LANDLORD.FUSION_CONTENTS,
  content: fusionContentsContent,
};
const rentDefault = {
  code: OptionalExtra.RentDefault,
  label: 'Tenants rent default cover',
  summaryLabel: 'Tenants rent default cover',
  image: ICONS.OPTIONAL_EXTRA.LANDLORD.RENT_DEFAULT,
  content: rentDefaultContent,
};

export const availableExtras: {
  [key in CoverType]: Extra[];
} = {
  [CoverType.Building]: [tenantDamage, lossOfRent, rentDefault, fusionBuilding],
  [CoverType.BuildingAndContents]: [
    tenantDamage,
    lossOfRent,
    rentDefault,
    fusionBuilding,
    fusionContents,
  ],
  [CoverType.Contents]: [tenantDamage, lossOfRent, rentDefault, fusionContents],
  [CoverType.Unspecified]: [],
};
